module.exports = __webpack_public_path__ + "static/media/visa.e1940f06.svg";